/*
 * ruleta.js — Ruleta de premios (Distrito Phone)
 * Giro con probabilidades por peso (weight). Premios con peso 0 nunca salen.
 */
(function () {
  'use strict';

  function initRoot(root) {
    var wheel = root.querySelector('[data-ruleta-wheel]');
    var spinBtn = root.querySelector('[data-ruleta-spin]');
    var stage = root.querySelector('[data-ruleta-stage]');
    var prizesEl = root.querySelector('[data-ruleta-prizes]');
    var resultEl = root.querySelector('[data-ruleta-result]');
    var prizeOut = root.querySelector('[data-ruleta-prize]');
    var closeBtn = root.querySelector('[data-ruleta-close]');
    var confetti = root.querySelector('[data-ruleta-confetti]');
    if (!wheel || !spinBtn || !prizesEl) return;

    var prizes;
    try { prizes = JSON.parse(prizesEl.textContent); } catch (e) { return; }
    if (!prizes || !prizes.length) return;

    var n = prizes.length;
    var seg = 360 / n;
    var rotation = 0;
    var spinning = false;

    var spinSound = root.getAttribute('data-spin-sound');
    var winSound = root.getAttribute('data-win-sound');

    function pickWeightedIndex() {
      var total = 0, i;
      for (i = 0; i < n; i++) total += Math.max(0, prizes[i].weight || 0);
      if (total <= 0) return 0;
      var r = Math.random() * total;
      var acc = 0;
      for (i = 0; i < n; i++) {
        acc += Math.max(0, prizes[i].weight || 0);
        if (r < acc) return i;
      }
      return n - 1;
    }

    function play(url) {
      if (!url) return;
      try { var a = new Audio(url); a.volume = 0.6; a.play().catch(function () {}); } catch (e) {}
    }

    function spin() {
      if (spinning) return;
      spinning = true;
      spinBtn.disabled = true;
      stage.classList.add('is-active');
      play(spinSound);

      var idx = pickWeightedIndex();
      // Centro del gajo (desde arriba, en sentido horario)
      var center = idx * seg + seg / 2;
      // Jitter dentro del gajo para que no caiga siempre al centro
      var jitter = (Math.random() - 0.5) * seg * 0.6;
      // Alinear el centro del gajo al puntero (arriba = 0deg)
      var current = rotation % 360;
      var delta = (360 - center - jitter - current + 720) % 360;
      rotation += 360 * 6 + delta; // 6 vueltas + alineación
      wheel.style.transform = 'rotate(' + rotation + 'deg)';

      var done = function () {
        wheel.removeEventListener('transitionend', done);
        showResult(prizes[idx].label);
      };
      wheel.addEventListener('transitionend', done);
    }

    function showResult(label) {
      play(winSound);
      if (prizeOut) prizeOut.textContent = label;
      if (resultEl) resultEl.hidden = false;
      launchConfetti();
    }

    function closeResult() {
      if (resultEl) resultEl.hidden = true;
      spinning = false;
      spinBtn.disabled = false;
      stage.classList.remove('is-active');
      stopConfetti();
    }

    spinBtn.addEventListener('click', spin);
    if (closeBtn) closeBtn.addEventListener('click', closeResult);
    if (resultEl) resultEl.addEventListener('click', function (e) { if (e.target === resultEl) closeResult(); });

    // ── Confeti ──
    var confCtx, confPieces = [], confRAF = null;
    function launchConfetti() {
      if (!confetti) return;
      confCtx = confetti.getContext('2d');
      confetti.width = confetti.offsetWidth;
      confetti.height = confetti.offsetHeight;
      var colors = ['#E11D2A', '#ffffff', '#c9a227', '#3f6fc0', '#4e7d63'];
      confPieces = [];
      for (var i = 0; i < 160; i++) {
        confPieces.push({
          x: Math.random() * confetti.width,
          y: -20 - Math.random() * confetti.height,
          w: 6 + Math.random() * 6,
          h: 8 + Math.random() * 8,
          c: colors[Math.floor(Math.random() * colors.length)],
          vy: 2 + Math.random() * 3,
          vx: -1.5 + Math.random() * 3,
          rot: Math.random() * 360,
          vr: -6 + Math.random() * 12
        });
      }
      cancelAnimationFrame(confRAF);
      animateConfetti();
    }
    function animateConfetti() {
      if (!confCtx) return;
      confCtx.clearRect(0, 0, confetti.width, confetti.height);
      confPieces.forEach(function (p) {
        p.y += p.vy; p.x += p.vx; p.rot += p.vr;
        if (p.y > confetti.height + 20) { p.y = -20; p.x = Math.random() * confetti.width; }
        confCtx.save();
        confCtx.translate(p.x, p.y);
        confCtx.rotate(p.rot * Math.PI / 180);
        confCtx.fillStyle = p.c;
        confCtx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        confCtx.restore();
      });
      confRAF = requestAnimationFrame(animateConfetti);
    }
    function stopConfetti() {
      cancelAnimationFrame(confRAF);
      if (confCtx) confCtx.clearRect(0, 0, confetti.width, confetti.height);
    }
  }

  function init() { document.querySelectorAll('[data-ruleta]').forEach(initRoot); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
